export interface BrandingConfig {
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  textOnPrimary?: string;
  buttonRadiusPx?: number;
  showAdminLoginLink?: boolean;
  isDarkHeader?: boolean;
  logoUrl?: string;
  faviconUrl?: string;
  ogImageUrl?: string;
  customCss?: string;
}

export const defaultBranding: Required<Pick<BrandingConfig,
  'primaryColor' | 'secondaryColor' | 'accentColor' | 'textOnPrimary' | 'buttonRadiusPx' | 'showAdminLoginLink' | 'isDarkHeader'
>> = {
  primaryColor: '#0F766E',
  secondaryColor: '#134E4A',
  accentColor: '#22C55E',
  textOnPrimary: '#FFFFFF',
  buttonRadiusPx: 8,
  showAdminLoginLink: true,
  isDarkHeader: false
};

export type BrandingUploadType = 'logo' | 'favicon' | 'og';

export interface BrandingUploadRequest {
  type: BrandingUploadType;
  filename: string;
  contentType: string;
}

export interface BrandingUploadResponse {
  url: string;
  fields?: Record<string, string>;
  publicUrl: string;
}










